//chapter1
export default {
    id : 16,//chapter number
    title : '16. 반도체 패키지 발전에 따른 공정 변화 (2)',//chapter name
    slides : [
        {
            title : 'Intro',
            type : 'intro',
            autoNext : 'N',//Y : yes , N: no
            nextBtn : 'Y',//Y : yes , N: no
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/16/videos/a16.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            autoNext : 'N',//Y : yes , N: no, P : popup
            duration : 20000,// default 20 sec  
            nextBtn : 'Y',//Y : yes , N: no
            body1 : [
                '반도체 패키징 시장의 주류 이동',
            ],
            body2 : [
                '반도체 패키징 시장의 주류 이동에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            autoNext : 'N',//Y : yes , N: no, P: popup
            nextBtn : 'Y',//Y : yes , N: no
            order : null, // if a chapter have multiple lessons, set order please ex)
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/16/videos/16.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    title : 'Quiz',
                    question : '플립칩과 웨이퍼 레벨 패키지는 기존에 만들어진 패드 위에 솔더범프를 형성시켜서 만들어진다.',//html available
                    answer : "2",
                    explain : '플립칩과 웨이퍼 레벨 패키지는 패드를 재배선하는 공정을 거친 후 솔더 범프를 형성시켜서 만들어진다.'
                },
                {
                    type : 'ox',
                    title : 'Quiz',
                    question : '팬아웃 웨이퍼레벨 패키지는 Input/Output 수를 늘리기 위해 칩외곽을 확장한 개념의 패키지이다.',//html available
                    answer : "1",
                    explain : '팬아웃 웨이퍼레벨 패키지는 Input/Output 수를 늘리기 위해 칩외곽을 에폭시로 확장한 후 재배선과 범핑을 했다. '
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask bg
            quizMaskStart : "../assets/images/quiz_intro_start.png",//quiz mask bg
            quizIntroText : "../assets/images/quiz_intro_text.png",//quiz mask bg
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            autoNext : 'N',//Y : yes , N: no
            duration : 20000,// default 20 sec  
            nextBtn : 'Y',//Y : yes , N: no
            //download : 'sample.pptx',//data folder
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <li>전자제품의 경박단소화, 다기능화 추세에 맞춰 반도체 패키징 시장의 주류가 소형화 및 고집적화 대응이 가능한 플립칩(Flip chip)으로 이동<br>
                        - 플립칩은 PCB나 리드프레임(leadframe) 같은 패키지 캐리어(carrier)와 다이를 전기적으로 연결하는데 있어 와이어(wire) 대신 다이의 알루미늄 패드(Pad) 위에 금(Gold) 또는 솔더(Solder) 등의 소재로 수십~수백µm 크기의 범프(bump)를 형성한 후 형성된 면을 캐리어에 직접 접합하는 방식<br>
                        - 플립칩 기술은 ▲신호(signal) 저항 계수 감소 ▲전기(power/ground) 저항 계수의 감소 ▲높은 신호(signal) 집적 ▲다이 사이즈 감소 ▲패키지 풋프린트(footprint) 감소 등 상당히 많은 이점 제공<br>
                        - 플립칩은 FCBGA, FCCSP, FCPoP, FC-eMMC, FC-Embedded로 분류되며 향후 FCBGA와 FCCSP 시장 성장<br>
                        - FC BGA : 수천핀급 초다핀화에 유리. 슈퍼컴퓨터, 워크스테이션 등 고성능 디바이스에 주로 채용<br>
                        - FC CSP : 패키지의 크기가 반도체 칩과 같아 소형화, 경량화, 고정밀화에 유리. 스마트폰의 슬림화, 다기능화 추세에 따라 수요 증가</li>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/16/videos/a16.mp4',
        },
    ]
}